// Security+ Domain Structure Data
// Extracted from App.js for better maintainability and token efficiency
// This file contains domain definitions and concept mappings

export const domains = [
  {
    id: 1,
    title: "1.0 General Security Concepts",
    percentage: "12%",
    color: "bg-purple-600",
    iconColor: "text-purple-600"
  },
  {
    id: 2,
    title: "2.0 Threats, Vulnerabilities, and Mitigations",
    percentage: "22%",
    color: "bg-orange-500",
    iconColor: "text-orange-500"
  },
  {
    id: 3,
    title: "3.0 Security Architecture",
    percentage: "18%",
    color: "bg-blue-500",
    iconColor: "text-blue-500"
  },
  {
    id: 4,
    title: "4.0 Security Operations",
    percentage: "28%",
    color: "bg-yellow-500",
    iconColor: "text-yellow-500"
  },
  {
    id: 5,
    title: "5.0 Security Program Management and Oversight",
    percentage: "20%",
    color: "bg-green-500",
    iconColor: "text-green-500"
  }
];

// Concept to Domain Mapping
export const conceptDomainMapping = {
  // Domain 1: General Security Concepts
  domain1: ['categories', 'technical', 'managerial', 'operational', 'physical', 'preventive', 'deterrent', 'detective', 'corrective', 'compensating', 'directive', 'cia-triad', 'non-repudiation', 'aaa', 'authenticating-people', 'authenticating-systems', 'authorization-models', 'gap-analysis', 'zero-trust', 'control-plane', 'adaptive-identity', 'threat-scope-reduction', 'policy-driven-access', 'policy-administrator', 'policy-engine', 'data-plane', 'implicit-trust-zones', 'subject-system', 'policy-enforcement-point', 'physical-security', 'bollards', 'access-control-vestibule', 'fencing', 'video-surveillance', 'security-guard', 'access-badge', 'lighting', 'sensors-physical', 'infrared-sensor', 'pressure-sensor', 'microwave-sensor', 'ultrasonic-sensor', 'deception-disruption-technology', 'honeypot', 'honeynet', 'honeyfile', 'honeytoken'],
  
  // Domain 2: Threats, Vulnerabilities, and Mitigations  
  domain2: ['threat-actors', 'nation-state', 'unskilled-attacker', 'hacktivist', 'insider-threat', 'organized-crime'],
  
  // Domain 3: Security Architecture
  domain3: ['cloud-security', 'network-segmentation', 'zero-trust-architecture'],
  
  // Domain 4: Security Operations
  domain4: ['siem', 'incident-response', 'vulnerability-management'],
  
  // Domain 5: Security Program Management
  domain5: ['governance', 'risk-management', 'compliance']
};

// Helper function to determine which domain a concept belongs to
export const getDomainFromKey = (key) => {
  if (conceptDomainMapping.domain1.includes(key)) {
    return 'Domain 1: General Security Concepts';
  }
  if (conceptDomainMapping.domain2.includes(key)) {
    return 'Domain 2: Threats, Vulnerabilities, and Mitigations';
  }
  if (conceptDomainMapping.domain3.includes(key)) {
    return 'Domain 3: Security Architecture';
  }
  if (conceptDomainMapping.domain4.includes(key)) {
    return 'Domain 4: Security Operations';
  }
  if (conceptDomainMapping.domain5.includes(key)) {
    return 'Domain 5: Security Program Management';
  }
  return 'General';
};